export const REGISTRATION_TRACKER_WARNING_STATUSES = new Set([
  "awaiting_documents",
  "waiting_information_details",
  "awaiting_payment_from_client",
  "correction_required",
  "office_action_issued",
  "awaiting_third_party_consent",
]);

export function normalizeRegistrationTrackerStatusValue(value) {
  if (value == null) return "";
  return String(value).trim().toLowerCase().replace(/-/g, "_");
}

export function isRegistrationTrackerActionNeededStatus(value) {
  return REGISTRATION_TRACKER_WARNING_STATUSES.has(
    normalizeRegistrationTrackerStatusValue(value)
  );
}

export const REGISTRATION_TRACKER_TERMINAL_STATUSES = new Set([
  "approved",
  "registration_issued",
  "completed",
  "rejected",
  "registration_canceled",
  "withdrawn",
  "abandoned",
  "expired",
]);

export function isRegistrationTrackerTerminalStatus(value) {
  return REGISTRATION_TRACKER_TERMINAL_STATUSES.has(
    resolveRegistrationTrackerStatusValue(value)
  );
}

export const REGISTRATION_TRACKER_STATE_COUNTRY_CODES = new Set(["USA", "CAN"]);

export function normalizeRegistrationTrackerJurisdictionKey(value) {
  if (value == null || value === "") return "";
  return String(value).trim().toUpperCase();
}

export function jurisdictionRequiresStateField(jurisdictionId) {
  return REGISTRATION_TRACKER_STATE_COUNTRY_CODES.has(
    normalizeRegistrationTrackerJurisdictionKey(jurisdictionId)
  );
}

export const REGISTRATION_TRACKER_STATUS_OPTIONS = [
  { label: "Awaiting Documents", value: "awaiting_documents" },
  { label: "Waiting information/details", value: "waiting_information_details" },
  { label: "Awaiting payment from the client", value: "awaiting_payment_from_client" },
  { label: "Documentation Received", value: "documentation_received" },
  { label: "Under Internal Review", value: "under_internal_review" },
  { label: "Ready for Filing", value: "ready_for_filing" },
  { label: "Filed", value: "filed" },
  { label: "In Government Review", value: "in_government_review" },
  { label: "Registration Issued", value: "registration_issued" },
  { label: "Rejected", value: "rejected" },
  { label: "Registration canceled", value: "registration_canceled" },
  { label: "Abandoned", value: "abandoned" },
  { label: "On Hold", value: "on_hold" },
];

/** Labels for statuses no longer offered in filters, create, or status change. */
const RETIRED_REGISTRATION_TRACKER_STATUS_LABELS = {
  correction_required: "Correction Required",
  office_action_issued: "Office Action Issued",
  response_filed: "Response Filed",
  awaiting_third_party_consent: "Awaiting Third-Party Consent",
  opposition_period: "Opposition Period",
  approved: "Approved",
  awaiting_original_documents: "Awaiting Original Documents",
  completed: "Completed",
  withdrawn: "Withdrawn",
  expired: "Expired",
};

export const REGISTRATION_TRACKER_ALLOWED_STATUS_VALUES = new Set(
  REGISTRATION_TRACKER_STATUS_OPTIONS.map((o) => o.value)
);

const STATUS_LABEL_BY_VALUE = {
  ...RETIRED_REGISTRATION_TRACKER_STATUS_LABELS,
  ...Object.fromEntries(
    REGISTRATION_TRACKER_STATUS_OPTIONS.map((o) => [o.value, o.label])
  ),
};

const STATUS_VALUE_ALIASES = {
  "awaiting-third-party-consent": "awaiting_third_party_consent",
};

export function resolveRegistrationTrackerStatusValue(value) {
  const key = normalizeRegistrationTrackerStatusValue(value);
  if (!key) return "";
  if (REGISTRATION_TRACKER_ALLOWED_STATUS_VALUES.has(key)) return key;
  const alias = STATUS_VALUE_ALIASES[key];
  if (alias && REGISTRATION_TRACKER_ALLOWED_STATUS_VALUES.has(alias)) return alias;
  return key;
}

export function formatRegistrationTrackerStatusLabel(value) {
  if (value == null || value === "") return "—";
  const canonical = resolveRegistrationTrackerStatusValue(value);
  if (canonical && STATUS_LABEL_BY_VALUE[canonical]) {
    return STATUS_LABEL_BY_VALUE[canonical];
  }
  const key = normalizeRegistrationTrackerStatusValue(value);
  if (key && STATUS_LABEL_BY_VALUE[key]) return STATUS_LABEL_BY_VALUE[key];
  return String(value)
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
